package structs.accelbyte.promo

import kotlinx.serialization.Serializable
import structs.accelbyte.common.AccelByteJson
import structs.accelbyte.common.AccelByteSerializable

/**
 * Operator request to list every code in the registry. Empty body
 * -- the server returns the full document.
 */
@Serializable
data class ListPromoCodesRequest(
    val unused: String = "",
) : AccelByteSerializable {
    override fun toJsonString(): String = AccelByteJson.encodeToString(serializer(), this)
}

/**
 * Server response carrying the registry document as a JSON string.
 * Wrapping in a string (instead of a structured payload) keeps the
 * schema-version coupling localized to the registry serializer; the
 * admin console re-decodes via the same kotlinx serializer on its end.
 */
@Serializable
data class ListPromoCodesResponse(
    val registryJson: String,
) : AccelByteSerializable {
    override fun toJsonString(): String = AccelByteJson.encodeToString(serializer(), this)
}

/**
 * Operator request to delete a single code by literal value.
 * Case-insensitive match on the server side.
 */
@Serializable
data class DeletePromoCodeRequest(
    val codeValue: String,
) : AccelByteSerializable {
    override fun toJsonString(): String = AccelByteJson.encodeToString(serializer(), this)
}

/**
 * Server response confirming deletion.
 */
@Serializable
data class DeletePromoCodeResponse(
    val deletedCode: String,
) : AccelByteSerializable {
    override fun toJsonString(): String = AccelByteJson.encodeToString(serializer(), this)
}
